var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTalkToUs = function SvgIconTalkToUs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5A855",
    d: "M5.805 6.902a8.8 8.8 0 0 0 3.293 3.293l.737-1.032a.833.833 0 0 1 1.078-.247 9.5 9.5 0 0 0 3.82 1.137.833.833 0 0 1 .767.83v3.72a.833.833 0 0 1-.748.829q-.663.068-1.335.068C6.283 15.5.5 9.717.5 2.583q0-.672.068-1.335A.833.833 0 0 1 1.398.5h3.718c.435 0 .797.334.83.768a9.5 9.5 0 0 0 1.138 3.819.833.833 0 0 1-.247 1.078zm-2.101-.548 1.583-1.13a11.2 11.2 0 0 1-.914-3.057H2.174q-.007.207-.007.416c0 6.214 5.037 11.25 11.25 11.25q.209 0 .416-.007v-2.199a11.2 11.2 0 0 1-3.056-.914l-1.131 1.584q-.688-.268-1.323-.625l-.049-.028a10.46 10.46 0 0 1-3.918-3.918l-.028-.049a10 10 0 0 1-.624-1.323"
  })));
};
export default SvgIconTalkToUs;